export const menuConfig = {
  sidebarItems: [
    {
      path: "/dashboard",
      label: "Dashboard",
      icon: "board-2",
      roles: [],
    },
    {
      path: "/analytics",
      label: "Analytics",
      icon: "board-2",
      roles: [],
    },
    {
      path: "/mgt",
      label: "User Management",
      icon: "grid-1",
      roles: [
        "viewusers",
        "viewfarmers",
        "viewcustomers",
        "viewvendors",
        "adduser",
        "edituser",
        "addfarmers",
        "editfarmers",
        "viewadmins",
        "addadmins",
        "editadmins",
        "viewroles",
      ],
      subs: [
        {
          path: "/admin-users",
          label: "Admin Users",
          icon: "shield",
          roles: ["viewadmins"],
        },
        {
          path: "/roles",
          label: "Roles",
          icon: "key",
          roles: ["viewroles"],
        },
        {
          path: "/farmers",
          label: "Value Chain Actors",
          icon: "leaf",
          roles: ["viewfarmers"],
        },
        {
          path: "/customers",
          label: "Customers",
          icon: "user",
          roles: ["viewcustomers"],
        },
        {
          path: "/vendors",
          label: "Vendors",
          icon: "shop",
          roles: ["viewvendors"],
        },
        {
          path: "/farmers/add",
          label: "Register",
          icon: "plus",
          roles: ["addfarmers"],
        },
      ],
    },
    {
      path: "/comm",
      label: "Communications",
      icon: "grid-1",
      roles: ["sendnotifications"],
      subs: [
        {
          path: "/sms",
          label: "Send SMS",
          icon: "message",
          roles: ["sendnotifications"],
        },
        {
          path: "/email",
          label: "Send Email",
          icon: "email",
          roles: ["sendnotifications"],
        },
        {
          path: "/push-notification",
          label: "Push Notification",
          icon: "notification",
          roles: ["sendnotifications"],
        },
      ],
    },
    {
      path: "/price",
      label: "Prices",
      icon: "grid-1",
      roles: ["viewprices", "addprices", "editprices"],
      subs: [
        {
          path: "/price",
          label: "Price",
          icon: "file-text",
        },
      ],
    },
    {
      path: "/products",
      label: "Products",
      icon: "grid-1",
      roles: [
        "viewproducts",
        "editproducts",
        "managecategories",
        "managereviews",
        "viewpromotions",
        "viewpromotionplans",
      ],
      subs: [
        {
          path: "/",
          label: "Products",
          icon: "shop",
          roles: ["viewproducts"],
        },
        {
          path: "/categories",
          label: "Categories",
          icon: "tag",
          roles: ["managecategories"],
        },
        {
          path: "/reviews",
          label: "Reviews",
          icon: "star",
          roles: ["managereviews"],
        },
        {
          path: "/promotions",
          label: "Promotion History",
          icon: "trend-up",
          roles: ["viewpromotions"],
        },
        {
          path: "/promotion-plans",
          label: "Promotion Plans",
          icon: "crown",
          roles: ["viewpromotionplans"],
        },
      ],
    },
    {
      path: "/content",
      label: "Contents",
      icon: "grid-1",
      roles: [
        "viewnews",
        "viewpartners",
        "viewpublications",
        "viewtools",
        "viewvideos",
        "viewfaqs",
      ],
      subs: [
        {
          path: "/news",
          label: "News",
          icon: "file-text",
          roles: ["viewnews"],
        },
        {
          path: "/partners",
          label: "Partners",
          icon: "user",
          roles: ["viewpartners"],
        },
        {
          path: "/publication",
          label: "Publications",
          icon: "book-open",
          roles: ["viewpublications"],
        },
        {
          path: "/tools",
          label: "Tools",
          icon: "tool",
          roles: ["viewtools"],
        },
        {
          path: "/video",
          label: "Video",
          icon: "video",
          roles: ["viewvideos"],
        },
        {
          path: "/faq",
          label: "FAQ",
          icon: "help",
          roles: ["viewfaqs"],
        },
      ],
    },
    {
      path: "/settings",
      label: "Settings",
      icon: "grid-1",
      roles: ["managesettings"],
      subs: [
        {
          path: "/about",
          label: "About",
          icon: "building-large",
        },
        {
          path: "/contact",
          label: "Contacts",
          icon: "phone",
        },
        {
          path: "/social-media",
          label: "Social Media",
          icon: "like",
        },
        {
          path: "/terms-and-conditions",
          label: "Terms & Conditions",
          icon: "file-text",
        },
        {
          path: "/privacy-policy",
          label: "Privacy Policy",
          icon: "lock-off",
        },
      ],
    },
  ],
  mainMenuItems: [],
};

export default menuConfig;
